import React, { Component } from 'react';
import { Link } from 'react-router';
import styles from './Slogan.css';

class Slogan extends Component {
  render() {
    return (
      <section className="container">
        <Link to="/about">
          <h1 className={styles.slogan}>
            Five Metal Shop is a creative studio <br />
            that designs business.
          </h1>
        </Link>
      </section>
    );
  }
}

export default Slogan;


// WEBPACK FOOTER //
// ./src/components/slogan/Slogan.js